module.exports = __webpack_public_path__ + "768ba41052ae39c27fd7676ebb282853.svg";